import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { getRootComponent } from "../../utilities/ElementUtils";
import { ButtonComponent } from "./ButtonComponent";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  isEng: boolean;
  callback,
  returnIndex?: number,
  callbackStepIndex: (index: number) => void;
}

interface State {


}
export class RepeatButtonComponent extends ButtonComponent {


  constructor(props: Props) {
    super(props);

  }



  render() {

    this.props.field.Script = `(field) => {
    try {
        const subSection = field.parent;
        let newSubSection = Object.assign({}, subSection);

        const sequence = subSection.Sequence;
        newSubSection.Id = (Number(subSection.Id) + 1).toString();
        newSubSection.Sequence = sequence + 1;
        const regex = /\(\d+\)/g;
        console.log(subSection.ENUTitle);
        const result = subSection.ENUTitle.trim().match(regex);
        console.log(result);
        if (result==null) {
            newSubSection.ENUTitle = subSection.ENUTitle.trim() + '(' + sequence.toString() + ')';
        } else {
            newSubSection.ENUTitle = subSection.ENUTitle.trim().replace(/\(\d+\)/g, '(' + sequence.toString() +')');
        }

        delete newSubSection.parent;
        const section = subSection.parent;
        newSubSection.parent = section;

        // Ensure ListOfFormSubSections is initialized and is an array
        if (!Array.isArray(section.ListOfFormSubSections)) {
            section.ListOfFormSubSections = [];
        }

        section.ListOfFormSubSections.push(newSubSection);
    } catch (ex) {
        console.log(ex)
    }
}`

    return super.render();
  }
}